import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=6896dfe2&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=6896dfe2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6896dfe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6896dfe2')) {
      api.createRecord('6896dfe2', component.options)
    } else {
      api.reload('6896dfe2', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=6896dfe2&scoped=true", function () {
      api.rerender('6896dfe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/Login.vue"
export default component.exports